/*Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/


import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { default as fragments } from '../../fragments'

import {
  SvgIcon,
  Table,
  Spinner,
  Button,
  Modal,
  SpanWithData,
  PageNavigationButtons,
  SMSSend,
  CheckboxToggle
} from '../'

import { EmployerRelatedMessages } from '../../containers'

import {
  decodeBase64,
  PageNavigationControl,
  getPageCursor
} from '../../utils'


class Messages extends Component {
  static propTypes = {
    fromEmployerGroupId: PropTypes.string,
    toEmployerGroupId: PropTypes.string,
    status: PropTypes.string,
    direction: PropTypes.string,
    messageType: PropTypes.string,
    fromAddr: PropTypes.string,
    toAddr: PropTypes.string,
    scheduledAtFrom: PropTypes.string,
    scheduledAtTo: PropTypes.string,
    timestampFrom: PropTypes.string,
    timestampTo: PropTypes.string,
    fromIdentityId: PropTypes.string,
    // toIdentityId: PropTypes.string,
    unknownParticipant: PropTypes.bool,
    orderBy: PropTypes.string,
    changeSort: PropTypes.func,
    resultsPerPage: PropTypes.number,
    className: PropTypes.string,
    employerIdentityId: PropTypes.string,
  }

  static defaultProps = {
    resultsPerPage: 15
  }

  state = {
    selectedMessage: null,
    replyToMessage: false,
    filterChanged: false,
    pageNav: new PageNavigationControl()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if ((this.props.status !== nextProps.status ||
      this.props.direction !== nextProps.direction ||
      this.props.messageType !== nextProps.messageType ||
      this.props.fromAddr !== nextProps.fromAddr ||
      this.props.toAddr !== nextProps.toAddr ||
      this.props.scheduledAtFromDate !== nextProps.scheduledAtFromDate ||
      this.props.scheduledAtToDate !== nextProps.scheduledAtToDate ||
      this.props.timestampFromDate !== nextProps.timestampFromDate ||
      this.props.timestampToDate !== nextProps.timestampToDate ||
      this.props.orderBy !== nextProps.orderBy) &&
      !sessionStorage.getItem('messageListPageState')
    ) {
      let previousFilters = JSON.parse(sessionStorage.getItem('messageListFilters'))
      if (previousFilters && (
        previousFilters.status === nextProps.status ||
        previousFilters.direction === nextProps.direction ||
        previousFilters.messageType === nextProps.messageType ||
        this.props.fromAddr !== nextProps.fromAddr ||
        this.props.toAddr !== nextProps.toAddr ||
        previousFilters.scheduledAtFromDate === nextProps.scheduledAtFromDate ||
        previousFilters.scheduledAtToDate === nextProps.scheduledAtToDate ||
        this.props.timestampFromDate !== nextProps.timestampFromDate ||
        this.props.timestampToDate !== nextProps.timestampToDate ||
        this.props.orderBy !== nextProps.orderBy
      )) {
        sessionStorage.removeItem('messageListFilters')
      } else {
        this.state.pageNav.reset()
        this.setState({
          filterChanged: true
        }, () => this.props.refetch())
        sessionStorage.removeItem('messageListFilters')
      }
    } else {
      if (!nextProps.loading) {
        if (this.state.filterChanged) {
          this.setState({
            filterChanged: false
          })
          this.state.pageNav.setPageStates(null, nextProps.messages)
        }
        else if (nextProps.messages) {
          let messageListPageState = JSON.parse(sessionStorage.getItem('messageListPageState'))
          if (messageListPageState) {
            this.state.pageNav.setPageStates(null, null, messageListPageState)
            sessionStorage.removeItem('messageListPageState')
          } else {
            this.state.pageNav.setPageStates(this.props.messages, nextProps.messages)
          }
        }
      }
    }
  }

  getTableRows = (messages) => (
    messages.map(({ node: message }) => (
      <MessageTableItem
        message={message}
        // identity={this.props.identity}
        actionColumn={this.props.actionColumn}
        expandMessage={this.state.selectedMessage === message.id}
        onExpandClick={messageId => this.setState({ selectedMessage: messageId })}
        onExpandCloseClick={() => this.setState({ selectedMessage: null })}
        messageIdentity={message.direction === 'INBOUND' && message.fromIdentity !== null
          ? message.fromIdentity
          : message.direction === 'OUTBOUND' && message.toIdentity !== null
            ? message.toIdentity
            : null
        }
        employerIdentityId={this.props.employerIdentityId}
        key={`message_${message.id}`} />
    ))
  )

  render() {
    if (this.props.loading) {
      return <Spinner className='slds-is-relative' />
    }

    if (this.props.error) {
      return <h1>Oh dear! We have an issue</h1>
    }

    let pageNav = this.state.pageNav
    let columns = ['Identity', 'Direction', 'Status', 'Date/Time', 'Type', 'Message']
    if (this.props.actionColumn) {
      columns.push(this.props.actionColumn.name)
    }

    let messages = this.props.messages
    let startCursor = messages.pageInfo.startCursor
    let totalCount = messages.totalCount

    return (
      <div className={this.props.className ? this.props.className : ''}>
        {messages.edges.length === 0
          ? <div className='slds-p-around_medium'>
              <SvgIcon
                variant='utility'
                symbol='info'
                size='small'
                colour='light'
                className='slds-m-right_medium'
              />
              {`No ${this.props.direction} messages.`}
            </div>
          : <Fragment>
              <Table
                columns={columns}
                rows={this.getTableRows(messages.edges)}
                objectRows={true}
                orderBy={this.props.orderBy}
                changeSort={this.props.changeSort}
                querySortableColumns={{
                  'Date/Time': {
                    orderByName: 'timestamp'
                  }
                }}
              />
              <PageNavigationButtons
                onNextClick={() => pageNav.nextPage(this.props.fetchNext)}
                onPreviousClick={() => pageNav.previousPage(this.props.fetchPrevious)}
                previousDisabled={pageNav.firstPage}
                nextDisabled={pageNav.lastPage}
                startCursor={startCursor}
                totalCount={totalCount}
                resultsPerPage={this.props.resultsPerPage}
                resultsText='messages'
                onPageNumberClick={pageNumber => this.props.refetch({ cursor: getPageCursor(pageNumber, this.props.resultsPerPage) })}
                className="slds-p-around_medium slds-float_right"
              />
            </Fragment>
        }
      </div>
    )
  }
}

class MessageTableItem extends Component {
  state = {
    showReplySMSCompose: false,
    showReplyMessage: false,
    relatedMessageView: false,
    refreshTimestamp: moment().unix()
  }

  render() {
    const { message, actionColumn, expandMessage, onExpandClick, onExpandCloseClick, messageIdentity, employerIdentityId } = this.props

    return (
      <tr onClick={() => onExpandClick(message.id)} className='clickable'>
        <td>
          {messageIdentity
            ? messageIdentity.fullName
            : 'Unknown'
          }
        </td>
        <td>
          <SpanWithData forField="MessageDirection" searchKey={message.direction} />
        </td>
        <td>
          <SpanWithData forField="MessageStatus" searchKey={message.status} />
        </td>
        <td>
          {["UNSENT", "QUEUED"].indexOf(message.status) > -1
            ? '-'
            : moment().isSame(moment(message.timestamp), 'day')
              ? moment(message.timestamp).format('hh:mm a')
              : moment(message.timestamp).format('lll')
          }
        </td>
        <td>
          {message.messageType
            ? <SpanWithData forField="MessageMessageType" searchKey={message.messageType} />
            : "Unknown"
          }
        </td>
        <td>
          <div
            className='slds-truncate'
            style={{ width: '200px' }}>
            {message.content}
          </div>
          {expandMessage &&
            <Modal
              body={
                this.state.relatedMessageView
                  ? <EmployerRelatedMessages
                      employerId={employerIdentityId}
                      messageId={message.id}
                      key={this.state.refreshTimestamp}
                    />
                  : <Fragment>
                      <div className='slds-grid'>
                        {message.toAddr &&
                          <CheckboxToggle
                              id='showRelatedMessageToggle'
                              label='Show message history view?'
                              checked={this.state.relatedMessageView}
                              onChange={() => (
                                this.setState(prevState => (
                                  { relatedMessageView: !prevState.relatedMessageView }
                                ))
                              )}
                              className='slds-col_bump-left slds-m-bottom_medium'
                            />
                        }
                      </div>
                      <p
                        className='slds-m-top_medium'
                        style={{
                          wordWrap: 'break-word',
                          workBreak: 'break-word',
                          whiteSpace: 'pre-line',
                          letterSpacing: '0.75px',
                          fontSize: '1.1em'
                        }}>
                        {message.content}
                      </p>
                      {employerIdentityId && message.direction === "INBOUND"
                        ? this.state.showReplySMSCompose
                          ? <SMSSend
                              toIdentityId={messageIdentity.id}
                              fromIdentityId={employerIdentityId}
                              fromAddr={message.channel.outboundAddr}
                              channelId={message.channel.id}
                              replyToMessage={message}
                              onChange={replyMessage => this.setState({ replyMessage })}
                              onMessageCreateSuccess={() => this.setState({ showReplySMSCompose: false, showReplyMessage: true })}
                              onCancelClick={() => this.setState({ showReplySMSCompose: false })}
                              sendButtonLabel='Send reply'
                              className='slds-p-top_medium'
                            />
                          : this.state.showReplyMessage
                            ? <Fragment>
                                <div className='u-font-weight-bolder'>
                                  Reply:
                                </div>
                                <p
                                  className='slds-p-around_small'
                                  style={{
                                    whiteSpace: 'normal', letterSpacing: '0.75px', fontSize: '1.1em',
                                    borderLeft: '2px solid green'
                                  }}>

                                  {this.state.replyMessage}
                                </p>
                              </Fragment>
                            : <Button onClick={() => this.setState({ showReplySMSCompose: true })}>
                                Reply to message
                              </Button>
                        : null
                      }
                    </Fragment>
              }
              footer={
                <div className='slds-align_absolute-center'>
                  {this.state.relatedMessageView &&
                    <Button
                      onClick={(e) => {
                        e.stopPropagation()  // prevents click on outer <tr> to be captured
                        this.setState({ refreshTimestamp: moment.unix() })
                      }}
                      className='slds-p-right_small'>
                      Refresh
                    </Button>
                  }
                  <Button
                    type='brand'
                    onClick={(e) => {
                      e.stopPropagation()  // prevents click on outer <tr> to be captured
                      this.setState({ showReplySMSCompose: false, relatedMessageView: false })
                      onExpandCloseClick()
                    }}>
                    Close
                  </Button>
                </div>
              }
            />
          }
        </td>
        {actionColumn &&
          <td>
            {messageIdentity !== null
              ? actionColumn.render(message.id, messageIdentity.id)
              : '-'
            }
          </td>
        }
      </tr>
    )
  }
}

const getMessages = gql`
  query($fromEmployerGroupId: UUID, $toEmployerGroupId: UUID, $fromEmployerId: UUID, $toEmployerId: UUID, $status: String, $direction: String, $messageType: String, $fromAddr: String, $toAddr: String, $timestampFrom: DateTime, $timestampTo: DateTime, $scheduledAtFrom: DateTime, $scheduledAtTo: DateTime, $fromIdentityId: UUID, $toIdentityId: UUID, $unknownSender: Boolean, $unknownReceiver: Boolean, $orderBy: String, $resultsPerPage: Int!, $cursor: String) {
    messages(fromIdentity_Employer_Employergroup_Id: $fromEmployerGroupId, toIdentity_Employer_Employergroup_Id: $toEmployerGroupId, fromIdentity_Employer_Id: $fromEmployerId, toIdentity_Employer_Id: $toEmployerId, status: $status, direction: $direction, messageType: $messageType, fromAddr_Icontains: $fromAddr, toAddr_Icontains: $toAddr, timestamp_Gte: $timestampFrom, timestamp_Lte: $timestampTo, scheduledAt_Gte: $scheduledAtFrom, scheduledAt_Lte: $scheduledAtTo, toIdentity_Id: $toIdentityId, fromIdentity_Id: $fromIdentityId, fromIdentity_Id_Isnull: $unknownSender, toIdentity_Id_Isnull: $unknownReceiver, orderBy: $orderBy, first: $resultsPerPage, after: $cursor) {
      totalCount
      edges {
        node {
          ...Message
        }
      }
      pageInfo {
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${fragments.message}
`

const getPreviousMessages = gql`
  query($fromEmployerGroupId: UUID, $toEmployerGroupId: UUID, $fromEmployerId: UUID, $toEmployerId: UUID, $status: String, $direction: String, $messageType: String, $fromAddr: String, $toAddr: String, $timestampFrom: DateTime, $timestampTo: DateTime, $scheduledAtFrom: DateTime, $scheduledAtTo: DateTime, $fromIdentityId: UUID, $toIdentityId: UUID, $unknownSender: Boolean, $unknownReceiver: Boolean, $orderBy: String, $resultsPerPage: Int!, $cursor: String) {
    messages(fromIdentity_Employer_Employergroup_Id: $fromEmployerGroupId, toIdentity_Employer_Employergroup_Id: $toEmployerGroupId, fromIdentity_Employer_Id: $fromEmployerId, toIdentity_Employer_Id: $toEmployerId, status: $status, direction: $direction, messageType: $messageType, fromAddr_Icontains: $fromAddr, toAddr_Icontains: $toAddr, timestamp_Gte: $timestampFrom, timestamp_Lte: $timestampTo, scheduledAt_Gte: $scheduledAtFrom, scheduledAt_Lte: $scheduledAtTo, toIdentity_Id: $toIdentityId, fromIdentity_Id: $fromIdentityId, fromIdentity_Id_Isnull: $unknownSender, toIdentity_Id_Isnull: $unknownReceiver, orderBy: $orderBy, last: $resultsPerPage, before: $cursor) {
      totalCount
      edges {
        node {
          ...Message
        }
      }
      pageInfo {
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${fragments.message}
`

const setUnknownParticipantQueryFilter = (unknownParticipant, direction, senderFilter) => {
  // 'directionCorrespondsToFilter', if applied to 'unknownSender' query filter, will be true if
  //    message direction is inbound
  // 'directionCorrespondsToFilter', if applied to 'unknownReceiver' query filter, will be true
  //    if message direction is outbound
  const directionCorrespondsToFilter = senderFilter
    ? direction === 'inbound'
    : direction === 'outbound'  // receiver

  return unknownParticipant && directionCorrespondsToFilter
   ? true
   : directionCorrespondsToFilter
     ? false
     : undefined
}

const withData = graphql(getMessages, {
  options: ({ fromEmployerGroupId, toEmployerGroupId, fromEmployerId, toEmployerId, status, direction, messageType, fromAddr, toAddr, timestampFrom, timestampTo, scheduledAtFrom, scheduledAtTo, fromIdentityId, toIdentityId, unknownParticipant, resultsPerPage = 15, orderBy }) => ({
    variables: {
      fromEmployerGroupId: fromEmployerGroupId
        ? decodeBase64(fromEmployerGroupId)
        : undefined,
      toEmployerGroupId: toEmployerGroupId
        ? decodeBase64(toEmployerGroupId)
        : undefined,
      fromEmployerId: fromEmployerId
        ? decodeBase64(fromEmployerId)
        : undefined,
      toEmployerId: toEmployerId
        ? decodeBase64(toEmployerId)
        : undefined,
      status,
      direction,
      messageType,
      fromAddr,
      toAddr,
      timestampFrom,
      timestampTo,
      scheduledAtFrom,
      scheduledAtTo,
      fromIdentityId: fromIdentityId
        ? decodeBase64(fromIdentityId)
        : undefined,
      toIdentityId: toIdentityId
        ? decodeBase64(toIdentityId)
        : undefined,
      unknownSender: setUnknownParticipantQueryFilter(unknownParticipant, direction, true),
      unknownReceiver: setUnknownParticipantQueryFilter(unknownParticipant, direction, false),
      resultsPerPage,
      orderBy
    },
    fetchPolicy: 'network-only'
  }),
  props: ({ ownProps: { fromEmployerGroupId, toEmployerGroupId, fromEmployerId, toEmployerId, status, direction, messageType, fromAddr, toAddr, timestampFrom, timestampTo, scheduledAtFrom, scheduledAtTo, fromIdentityId, toIdentityId, unknownParticipant, resultsPerPage = 15, orderBy }, data: { loading, error, refetch, messages, fetchMore } }) => ({
    loading,
    error,
    refetch,
    messages,
    fetchNext: () => {
      return fetchMore({
        query: getMessages,
        variables: {
          fromEmployerGroupId: fromEmployerGroupId
            ? decodeBase64(fromEmployerGroupId)
            : undefined,
          toEmployerGroupId: toEmployerGroupId
            ? decodeBase64(toEmployerGroupId)
            : undefined,
          status,
          direction,
          messageType,
          fromAddr,
          toAddr,
          timestampFrom,
          timestampTo,
          scheduledAtFrom,
          scheduledAtTo,
          fromIdentityId: fromIdentityId
            ? decodeBase64(fromIdentityId)
            : undefined,
          toIdentityId: toIdentityId
            ? decodeBase64(toIdentityId)
            : undefined,
          unknownSender: setUnknownParticipantQueryFilter(unknownParticipant, direction, true),
          unknownReceiver: setUnknownParticipantQueryFilter(unknownParticipant, direction, false)
            ? true
            : undefined,
          orderBy,
          resultsPerPage,
          cursor: messages.pageInfo.endCursor
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const newEdges = fetchMoreResult.messages.edges
          const pageInfo = fetchMoreResult.messages.pageInfo
          return {
            messages: {
              __typename: previousResult.messages.__typename,
              edges: [...newEdges],
              pageInfo
            }
          }
        }
      })
    },
    fetchPrevious: () => {
      return fetchMore({
        query: getPreviousMessages,
        variables: {
          fromEmployerGroupId: fromEmployerGroupId
            ? decodeBase64(fromEmployerGroupId)
            : undefined,
          toEmployerGroupId: toEmployerGroupId
            ? decodeBase64(toEmployerGroupId)
            : undefined,
          status,
          direction,
          messageType,
          fromAddr,
          toAddr,
          timestampFrom,
          timestampTo,
          scheduledAtFrom,
          scheduledAtTo,
          fromIdentityId: fromIdentityId
            ? decodeBase64(fromIdentityId)
            : undefined,
          toIdentityId: toIdentityId
            ? decodeBase64(toIdentityId)
            : undefined,
          unknownSender: setUnknownParticipantQueryFilter(unknownParticipant, direction, true),
          unknownReceiver: setUnknownParticipantQueryFilter(unknownParticipant, direction, false),
          orderBy,
          resultsPerPage,
          cursor: messages.pageInfo.startCursor
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const newEdges = fetchMoreResult.messages.edges
          const pageInfo = fetchMoreResult.messages.pageInfo
          return {
            messages: {
              __typename: previousResult.messages.__typename,
              edges: [...newEdges],
              pageInfo
            }
          }
        }
      })
    }
  })
})

export default withData(Messages)



// WEBPACK FOOTER //
// ./src/components/messages/index.js